module.exports = __webpack_public_path__ + "img/photo-4.fe41f300.webp";